/// <amd-module name="Wit/Settings/BoardsExternalIntegration/components/panels/orgSelection/OrgSelectionPanel.Props" />
import { ExternalGitRepo } from "Wit/Clients/Internal/Contracts/ExternalEvents";
import { ExternalConnection } from "Wit/Clients/Internal/Contracts/WorkItemTracking";
import { IBasePanelContentProps } from "Wit/Settings/BoardsExternalIntegration/components/panels/BasePanelContent.Props";

export interface IOrgSelectionPanelProps extends IBasePanelContentProps {
    connection: ExternalConnection;
    onSave: (connection: ExternalConnection, orgName: string) => Promise<ExternalConnection>;
    reposFromSameProvider: ExternalGitRepo[];
    existingConnection: ExternalConnection[];
}
